export function formatHour(hour: number): string {
  const period = hour >= 12 ? 'PM' : 'AM';
  let displayHour = hour % 12;
  if (displayHour === 0) {
    displayHour = 12;
  }
  return `${displayHour}:00 ${period}`;
}
